<template>
  <div class="publish-task-product">
    <steps :active="2"></steps>
    <el-row class="normal-from mobile-container">
      <el-col :xs="24" :sm="8" :md="8" :lg="8" :offset="8" class="mobile-offset">
        <h3>设置下单条件</h3>
        <ConditionForm :loading="loading" :taskInfo="taskInfo" v-on:success="submit"></ConditionForm>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Steps from './../components/Steps'
import ConditionForm from './Form'
import api from '../../../services/api.js'

export default {
  name: 'AddAddress',
  components: {
    steps: Steps,
    ConditionForm: ConditionForm
  },
  computed: {
    taskInfo () {
      return this.$store.state.taskInfo
    }
  },
  created () {
    this.checkIsSingle()
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async submit () {
      let payment = await this.getLatestPaymentType()
      let path = 'payment'
      if (this.isSingle) {
        path = 'confirm'
      } else if (payment) {
        this.taskInfo.payment_type_id = payment.id
        this.taskInfo.payment_type_info = payment
        path = 'confirm'
      }
      this.$store.commit('updateTaskInfo', this.taskInfo)
      this.$router.push({ path: path, query: this.$route.query }).catch(err=>{err})
    },
    async getLatestPaymentType () {
      let res = await api.getLatestPaymentType(this)
      return res.body.result
    },
    checkIsSingle () {
      this.isSingle = this.$route.fullPath.indexOf('buyer') > -1
    }
  },
  watch: {
    $route () {
      this.checkIsSingle()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media screen and (max-width:769px){
  .mobile-container {
    padding: 0 10px;
    h3 {
      margin: 10px 0 20px;
    }

    .mobile-offset {
      margin-left: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/condition/Condition.vue